import { render, staticRenderFns } from "./UserForbiddenPage.vue?vue&type=template&id=43b49b1d&"
import script from "./UserForbiddenPage.vue?vue&type=script&lang=js&"
export * from "./UserForbiddenPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports